module.exports = __webpack_public_path__ + "img/wechat-qrcode.6d3f34b8.png";